import * as React from 'react';
import { useEffect, useLayoutEffect, useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from "react-i18next";
import useMenuAction from "../../../../../hooks/menu/useMenuAction";
import useMenuData from "../../../../../hooks/menu/useMenuData";
import useConfig from "../../../../../hooks/theme/useConfig";
import useUserData from "../../../../../hooks/user/useUserData";
import { CHECKLISTS } from "../../../../../locales/pages/namespaces";
import { NAVIGATION } from "../../../../../locales/components/namespaces";
import { HORIZONTAL_MAX_ITEM, MenuOrientation } from "../../../../../themes/config";
import { menuOptions } from "../../menuItems/menuOptions";
import NavGroup from './navGroup';

const Navigation = () => {
	const { i18n, t } = useTranslation([NAVIGATION, CHECKLISTS])
	const { language } = useUserData()
	const { drawerOpen, selectedLevel, selectedItems, menuItems } = useMenuData()
	const { setSelectedItems, setSelectedLevel, setDrawerOpen, setMenuItems } = useMenuAction()
	const theme = useTheme();
	const { menuOrientation } = useConfig();
	const downLG = useMediaQuery(theme.breakpoints.down('lg'));
	
	useEffect(() => {
		i18n.changeLanguage(language)
	}, [i18n, language])
	
	useLayoutEffect(() => {
		setMenuItems( [...menuOptions({
				t: t,
			})])
	}, []);
	
	const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;
	const navGroups = useMemo(() => {
		const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
		let lastItemIndex = menuItems.length - 1;
		let remItems = [];
		let lastItemId;
		//  first it checks menu item is more than giving HORIZONTAL_MAX_ITEM after that get lastItemid by giving horizontal max
		// item, and it sets horizontal menu by giving horizontal max item lastly slice menuItem from array and set into remItems
		if (lastItem && lastItem < menuItems.length) {
			lastItemId = menuItems[lastItem - 1].id;
			lastItemIndex = lastItem - 1;
			remItems = menuItems.slice(lastItem - 1, menuItems.length).map((item) => ({
				title: item.title,
				elements: item.children,
				icon: item.icon
			}));
		}
		
		return (
			menuItems.slice(0, lastItemIndex + 1).map((item) => {
				switch (item.type) {
					case 'group':
						return (
							<NavGroup
								key={item.id}
								setSelectedItems={setSelectedItems}
								setSelectedLevel={setSelectedLevel}
								selectedLevel={selectedLevel}
								selectedItems={selectedItems}
								lastItem={lastItem}
								remItems={remItems}
								lastItemId={lastItemId}
								item={item}
							/>
						);
					default:
						return (
							<Typography key={item.id} variant="h6" color="error" align="center">
								Fix - Navigation Group
							</Typography>
						);
				}
			})
		)
	}, [selectedItems, selectedLevel, setSelectedItems, setSelectedLevel, menuItems])
	
	return (
		<Box
			sx={{
				pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
				'& > ul:first-of-type': { mt: 0 },
				display: 'flex',
				justifyContent: 'center',
				p: drawerOpen ? '2rem' : 2
			}}
		>
			{navGroups}
		</Box>
	);
};

export default Navigation;
